var ISPyB =
{
    sites: [
        {
            name        : "ESRF",
            server      : "https://ispyb.esrf.fr/ispyb/ispyb-ws/rest",            
            description : "European Synchroton Radiation Facility",
            icon        : "../images/site/esrf.png",
            dataAnalysis: {
                enabled: true,
                url: "https://is4a.esrf.fr"                
                //url: "http://lindemaria:8000"                
            },
            settings : {
                themes : ["cerulean", "cosmo", "cyborg", "darkly", "flatly", "journal", "lumen", "paper", "readable", "sandstone", "simplex", "slate", "spacelab", "superhero", "united", "yeti" ],
                MX : {
                    showQualityIndicatorPlot : true, // It shows or hides the quality indicator plot from the summary tab of a datacollection
                    showCollectionTab : true,
                    showCrystalSnapshot1 : true,
                    showCrystalSnapshot2 : true,
                    showCrystalSnapshot3 : true,
                    showCrystalSnapshot4 : true
                }
            },
            beamlines: {
                SAXS: [{ name: "BM29" }],
                EM: [{ name: "CM01"}],
                MX: [{ name: "ID23-1", sampleChangerType: 'FlexHCDDual'},
                    { name: "ID23-2", sampleChangerType: 'FlexHCDUnipuckPlate'},
                    { name: "ID29", sampleChangerType: 'FlexHCDDual'},
                    { name: "ID30A-1", sampleChangerType: 'RoboDiffHCDSC3'},
                    { name: "ID30A-2", sampleChangerType: 'FlexHCDDual'},
                    { name: "ID30A-3", sampleChangerType: 'FlexHCDDual'},
                    { name: "ID30B", sampleChangerType: 'FlexHCDDual'},
                    { name: "BM30A", sampleChangerType: 'FlexHCDDual'}                   
                ]
            }
        },
        {
            server: "https://ispyb.maxiv.lu.se/ispyb/ispyb-ws/rest",            
            name: 'MAXIV',
            description: 'MAX IV Laboratory',
            icon: '../images/site/esrf.png',
            dataAnalysis: {
                enabled: false               
            },
            settings : {
                themes : ["cerulean", "cosmo", "cyborg", "darkly", "flatly", "journal", "lumen", "paper", "readable", "sandstone", "simplex", "slate", "spacelab", "superhero", "united", "yeti" ],
                MX : {
                    showQualityIndicatorPlot : false,
                    showCollectionTab : false,                    
                    showCrystalSnapshot1 : true,
                    showCrystalSnapshot2 : true,
                    showCrystalSnapshot3 : false,
                    showCrystalSnapshot4 : false
                }
            },
            beamlines: {
                SAXS:[],
                MX:[
                    { name : "BioMAX", sampleChangerType : 'ISARA'}
                ]                
            }
        },
          {
         server:'http://ispyb.embl-hamburg.de/ispyb/ispyb-ws/rest',
         name:'EMBL',
         description: 'European Molecular Biology Laboratory (Hamburg) ',
         dataAnalysis: {
                enabled: false               
         },
         settings : {
                themes : ["cerulean", "cosmo", "cyborg", "darkly", "flatly", "journal", "lumen", "paper", "readable", "sandstone", "simplex", "slate", "spacelab", "superhero", "united", "yeti" ],
                MX : {
                    showQualityIndicatorPlot : true,
                    showCollectionTab : true,                    
                    showCrystalSnapshot1 : true,
                    showCrystalSnapshot2 : true,
                    showCrystalSnapshot3 : true,
                    showCrystalSnapshot4 : true
                }
            },
            beamlines: {
                SAXS:[],
                MX:[
                    { name : "P13", sampleChangerType : 'FlexHCDDual'},
                    { name : "P14", sampleChangerType : 'FlexHCDDual'}
                ]                
            }
      }
    ]
};

export default ISPyB;



// WEBPACK FOOTER //
// ./src/config/config.js